export default "__VITE_ASSET__oE4OrLbH__"